import { FieldPath, serverTimestamp } from 'firebase/firestore';

// Fact names are admin-authored (Firestore-driven extraction configs) and can
// contain characters that are illegal in dotted string field paths ("/" in
// "Fracture/Injury Detail" broke every dotted-path write silently). FieldPath
// segments accept any characters, so all structuredInfo writes must go
// through these helpers, never template-string paths.

export function factFieldPath(factName, property) {
    return new FieldPath('structuredInfo', factName, property);
}

export function factUpdateArgs(factName, property, value) {
    return [
        factFieldPath(factName, property), value,
        new FieldPath('last_modified_date'), serverTimestamp(),
    ];
}

// D6: a Correct, Modify or Uncheck click writes verified and the reviewer.
export function factReviewArgs(factName, verified, stamp) {
    return [
        factFieldPath(factName, 'verified'), verified,
        factFieldPath(factName, 'review'), stamp,
        new FieldPath('last_modified_date'), serverTimestamp(),
    ];
}

// Admin Mark all correct. Facts that are already verified keep their
// reviewer; only the rest get verified: true and the bulk stamp.
export function markAllVerifiedArgs(structuredInfo, stamp) {
    const args = [];
    Object.entries(structuredInfo || {}).forEach(([key, value]) => {
        if (value?.verified === true) return;
        args.push(factFieldPath(key, 'verified'), true, factFieldPath(key, 'review'), stamp);
    });
    args.push(new FieldPath('last_modified_date'), serverTimestamp());
    return args;
}
